import { render, staticRenderFns } from "./_siteChangeItem.vue?vue&type=template&id=d8e71f20&scoped=true"
import script from "./_siteChangeItem.vue?vue&type=script&lang=js"
export * from "./_siteChangeItem.vue?vue&type=script&lang=js"
import style0 from "./_siteChangeItem.vue?vue&type=style&index=0&id=d8e71f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e71f20",
  null
  
)

export default component.exports